import { render, staticRenderFns } from "./competitorStatus.vue?vue&type=template&id=125cc90c&"
import script from "./competitorStatus.vue?vue&type=script&lang=js&"
export * from "./competitorStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports